<template>
  <div class="card questions">
    <div class="card-header">
      <h3 class="card-title">{{ $t('page.title.statistics') }}</h3>
    </div>
    <div class="card-body">
      <b-card no-body>
        <b-tabs card>
          <!-- Add your b-tab components here -->
          <template #tabs-end>
            <b-nav-item :active="$route.name === 'game'"
                         @click="goToPage('game')">
              {{$t('statistics.tab.game')}}</b-nav-item>
            <b-nav-item :active="$route.name === 'question'"
                        @click="goToPage('question')">
              {{$t('statistics.tab.question')}}</b-nav-item>
            <b-nav-item :active="$route.name === 'player'"
                        @click="goToPage('player')">
              {{$t('statistics.tab.player')}}</b-nav-item>
            <b-nav-item :active="$route.name === 'financial'"
                        @click="goToPage('financial')">
              {{$t('statistics.tab.financial')}}</b-nav-item>
          </template>
          <template #default>
            <div class="tab-pane active card-body">
              <router-view></router-view>
            </div>
          </template>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>

export default {
  props: ['apiKey'],
  components: {
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    goToPage(name) {
      this.$router.push({name: name});
    },
  }
}
</script>
